module.exports = __webpack_public_path__ + "abe941c5f4c0163b8227d5f1359015c8.svg";